import { getThemeColor, Styles } from "@mcleod/core";

export const HeadingTableCellResizerStyles = Styles.make("tblcr", () => {
    return {
        resizer: {
            position: "absolute",
            top: "15%",
            right: "0",
            width: "5px",
            marginLeft: "2px",
            marginRight: "2px",
            height: "70%",
            cursor: "col-resize",
            zIndex: "1",
            borderRight: "1px solid",
            borderRightColor: getThemeColor('subtle.lighter'),
        },
        isResizing: {
            cursor: "col-resize !important",
        },
    }
});
